import { CategoryInput } from 'common/form/input/_categoryInput'
import { useHistoryStudentFilterForm } from '../../../../hooks/useHistoryStudentFilterForm'

export const ProductSearch = () => {
  const {product} = useHistoryStudentFilterForm()
  return (
  <CategoryInput
    className={'order-filter-form__input-wide'}
    categoryList={[]}
    categoryValue={{name: 'Sản phẩm', value: ''}}
    categoryWidth={84}
    placeholder='Nhập tên sản phẩm'
    value={product?.value || ''}
    onChange={product.onChange}
    style={{ position: 'relative'}}
  />
  )
}
